import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from '../services/base.service';
import { WhatsNewState } from './whats-new.config';

/**
 * Novidades vistas por usuário, guardadas no servidor (/users/me/whats-new). Preferência do usuário,
 * não da empresa: as chamadas não passam pelo tratamento de erro do BaseService (sem toast). Falha
 * só chega ao chamador, que segue sem marcar nada como visto.
 */
@Injectable({ providedIn: 'root' })
export class WhatsNewApiService extends BaseService {
  constructor() {
    super('api/users/me/whats-new');
  }

  /** Primeiro acesso e novidades já vistas. */
  public getState(): Observable<WhatsNewState> {
    return this.http.get<WhatsNewState>(this.buildUrl(''), { headers: this.authHeader() });
  }

  /** Marca a novidade como vista (204, sem corpo de resposta). */
  public markSeen(id: string): Observable<void> {
    return this.http.put<void>(this.buildUrl(`/${encodeURIComponent(id)}/seen`), {}, { headers: this.authHeader() });
  }
}
